




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteEquipamentosStore from '@/components/Suporte/Store/SuporteEquipamentosStore'

@Component
export default class ComponentModalSuporteGrupoEquipamento extends Vue {
  loadSaveOrUpdateGrupoEquipamento: boolean = false

  get getSuporteEquipamentosStore() {
    return getModule(SuporteEquipamentosStore, this.$store)
  }

  get loadingSaveOrUpdateGrupoEquipamento() {
    return this.loadSaveOrUpdateGrupoEquipamento
  }

  set loadingSaveOrUpdateGrupoEquipamento(value: boolean) {
    this.loadSaveOrUpdateGrupoEquipamento = value
  }

  get showModalGrupoEquipamento() {
    return this.getSuporteEquipamentosStore.modal.grupoEquipamento
  }

  set showModalGrupoEquipamento(value: boolean) {
    this.getSuporteEquipamentosStore.setModal({ name: 'grupoEquipamento', value })
  }

  $refs!: {
    formGrupoEquipamento: any
  }

  formGrupoEquipamentoRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdateGrupoEquipamento() {
    this.loadingSaveOrUpdateGrupoEquipamento = true

    if (this.$refs.formGrupoEquipamento.validate()) {
      const { mode } = this.getSuporteEquipamentosStore

      const response = await this.getSuporteEquipamentosStore.upsertGrupoEquipamentoByHospital()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Grupo de equipamentos ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteEquipamentosStore.getGrupoEquipamentoPagedSearch(this.getSuporteEquipamentosStore.paginationGruposEquipamentos)
        await this.getSuporteEquipamentosStore.getAllGruposDeEquipamentos()
        this.showModalGrupoEquipamento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o grupo de equipamentos ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateGrupoEquipamento = false
  }

  @Watch('showModalGrupoEquipamento')
  onChangeShowModalGrupoEquipamento(value: boolean) {
    if (!value) {
      this.getSuporteEquipamentosStore.clearGrupoEquipamento()
      this.getSuporteEquipamentosStore.setMode({ mode: 'CREATE' })
      this.$refs.formGrupoEquipamento.resetValidation()
    }
  }
}
